<template>
    <hts-form-select
        v-model="cValue"
        v-model:text="cText"
        :query="query"
        :filterable="filterable"
        :clearable="clearable"
        :label="label"
        :required="required"
        :selected-multiple="selectedMultiple"
        :multiple="multiple"
        :prop="prop"
        :name="name || prop"
        :disabled="disabled"
        :readonly="readonly"
        :key-id="keyId"
        :key-label="keyLabel"
        :key-tooltip="keyTooltip"
        :confirm-change="confirmChange"
        :title-confirm="titleConfirm"
        :detail-confirm="detailConfirm"
        @change="handleChange" />
</template>

<script lang="ts" setup>
const props = defineProps({
  modelValue: { type: [Array, String], default: () => '' },
  multiple: { type: Boolean, default: false },
  text: { type: String, default: '' },
  selectedMultiple: { type: [Array, Object], default: () => [] },
  required: { type: Boolean, default: false },
  name: { type: String, default: 'nodeType' },
  prop: { type: String, default: 'nodeType' },
  label: { type: String, default: () => $t('labels.nodeType') },
  filterable: { type: Boolean, default: true },
  clearable: { type: Boolean, default: false },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false },
  keyTooltip: { type: String },
  keyId: { type: String, default: '_id' },
  keyLabel: { type: String, default: 'name' },
  confirmChange: { type: Boolean, default: false },
  titleConfirm: { type: String || undefined, default: undefined },
  detailConfirm: { type: String || undefined, default: undefined }
})

const emits = defineEmits(['update:modelValue', 'update:text', 'click'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const { modelValue, name, required, multiple, text } = toRefs(props)

const query = async (s: string) => {
  const api: any = $urlAdmin.node.type.finds

  const res = await $api(api, { uriParams: { KEY: s } })
  const resData: any = res?.data?.value
  if (resData?.success) {
    return resData.data
  }
  return []
}
const cText = computed({
  get () {
    return text.value || ''
  },
  set (val: any) {
    emits('update:text', val)
  }
})
const information = ref([])

const handleChange = (val: any) => {
  information.value = val
}
</script>
